import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ProjectItem from './project_item';
import {ProjectApi} from "../../customer_project/api/project-api";
import {isDesignFix} from "../../common/components/ProjectStatus/utils";

const welcomeMessageKey = 'MBR-PROJECTS-WELCOME-MESSAGE';
const timeRequestedKey = 'MBR-PROJECTS-ADDITIONAL-TIME-REQUESTED';

export default function CustomerProjectsList({ projects, userName, proPlatform, showAddMoreTimeMessage, hasShoppingCredits }) {
  const saveWelcomeMessageState = () => localStorage.setItem(welcomeMessageKey, 'done');
  const shouldShowWelcomeMessage = () => localStorage.getItem(welcomeMessageKey) !== 'done';
  const [projectsList] = useState(projects);
  const [showWelcomeMessage, setShowWelcomeMessage] = useState(shouldShowWelcomeMessage());

  const saveTimeRequestedState = () => localStorage.setItem(timeRequestedKey, new Date().toLocaleDateString('en-GB'));
  const timeRequestedSaved = () => localStorage.getItem(timeRequestedKey) == new Date().toLocaleDateString('en-GB');
  const [timeRequested, setTimeRequested] = useState(showAddMoreTimeMessage && timeRequestedSaved());

  const closeWelcomeMessage = () => {
    saveWelcomeMessageState();
    setShowWelcomeMessage(state => false);
  };

  const designFixDesignOnly = () => {
    let designFixProjectsCnt = 0;
    projects.forEach(project => {
      if (isDesignFix(project.room_type)) {
        designFixProjectsCnt += 1;
      }
    });
    return projects && projects.length === designFixProjectsCnt;
  };

  // function requestMoreTimeOnClick() {
  //   ProjectApi.requestAdditionalTime(
  //     response => {
  //       setTimeout(() => {
  //         saveTimeRequestedState();
  //         setTimeRequested(true);
  //       }, 500);
  //       return response;
  //     },
  //     response => {
  //       alert('Sorry. Something went wrong.');
  //       return response;
  //     },
  //   );
  // }

  // function anyArchivedProjects() {
  //   console.log(showAddMoreTimeMessage);
  //   const arcvhivedProjects = projectsList.filter(project => {
  //     return project.plan !== "consultancy" && project.status == "archived"
  //   });
  //   return arcvhivedProjects.length > 0;
  // }

  function renderAddMoreTimeMessage() {
    return;
  };

  function renderAddMoreTimeMessageBackup() {
    if (proPlatform) {
      return;
    };

    if (designFixDesignOnly()) {
      return (
        <div
          className={cn('internal-page -wide customer-projects-welcome_wrapper -complete-project')}
        >
          <div className="customer-projects-welcome">
            <h2>
              Hi &nbsp;{userName},
            </h2>
            <p>
              Your design session is now complete, we hope you’re thrilled with the results!
            </p>
            <p>
              If you’d like any further help, just drop us a note. We’d love to support you.
            </p>
            <p>
              Team MBR x
            </p>
          </div>
        </div>
      );
    };

    return (
      <div
        className={cn('internal-page -wide customer-projects-welcome_wrapper -complete-project')}
      >
        <div className="customer-projects-welcome">
          <h2>
            Hi &nbsp;{userName},
          </h2>
          <p>
            Your time with your designer may have wrapped up, but this is just the beginning of bringing your room to life.
          </p><p>
            You continue to benefit from <b>exclusive savings</b>, our <b>price match promise</b> and <b>dedicated shopping support</b>.
          </p><p>
            I’m here to help with everything - from coordinating deliveries to managing samples and timelines - for as long as you need.
          </p><p>
            If you’d like to chat, simply send me a message in the CHAT or book a call below.
          </p><p>
            <a className="btn btn-reversed -y2025 -case-as-is -longer" href="https://meetings.hubspot.com/sian-mclernon" target="_blank" rel="noopener">Book a call with Sian </a>
          </p><p>
            Looking forward to helping you bring it all together.
          </p><p>
            Sian x
          </p>
        </div>
      </div>
    )
  };

  return (
    <div className="container">
      {!proPlatform && !showAddMoreTimeMessage && (
        <div
          className={cn('internal-page -wide customer-projects-welcome_wrapper', {
            '-closed': !showWelcomeMessage,
          })}
        >
          <div className="customer-projects-welcome">
            <button
              className="customer-projects-welcome_close"
              onClick={() => closeWelcomeMessage()}
            />
            <h2>
              Hey&nbsp;
              {userName}, your design journey starts here! ✨
            </h2>
            <p> You’ve just landed in your very own design dashboard - the hub where all the magic happens!</p>
            <p>
              Here’s where you can keep tabs on your project’s progress, chat with your designer and then shop your completed design.
            </p>
            <p>
              The design journey usually takes up to 3 weeks. So, to get the most out of the experience, make sure to check in regularly and stay connected with your designer.
            </p>
            <p>
              We’re thrilled to have you with us and can’t wait to bring your dream space to life. Let’s do this! 💪
            </p>
            <p> Team My Bespoke Room x</p>
          </div>
        </div>
      )}
      {showAddMoreTimeMessage && renderAddMoreTimeMessage()}

      <div className="customer-projects-list internal-page -wide">
        <div className='heading'>
          <h1 className="internal-page_header title" id="my-projects">
            My Design Projects
          </h1>
        </div>
        {projects.length === 0 && (
          <div className="customer-projects-list_item -nothing-found">You have no design projects yet.</div>
          //   add a button to book a free call
        )}
        {projectsList.map(project => (
          <ProjectItem project={project} proPlatform={proPlatform} hasShoppingCredits={hasShoppingCredits} key={project.id} />
        ))}
      </div>
    </div>
  );
}

CustomerProjectsList.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape([])).isRequired,
  userName: PropTypes.string.isRequired,
  proPlatform: PropTypes.bool,
  showAddMoreTimeMessage: PropTypes.bool,
  hasShoppingCredits: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/components/customer_projects_list/index.js